<script lang="ts">
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import Zact from '../_common/z/zact.svelte'
    import dayjs from 'dayjs'
    import type { IComission } from './comissions.interface'
    import { createEventDispatcher, onMount } from 'svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import type { Invoice } from '../../modules/posApi/invoices/invoice'
    const dispatch = createEventDispatcher()

    export let detail: IComission

    let source = ''

    let invoice: Invoice = null
    onMount(async () => {
        console.log('detail', detail)
        if (detail.source === 'scheduler') {
            source = ''
            if (detail.details.comissionPriceSource === 'pos') {
                if (detail.invoiceIdType === 'referenced') {
                    source = 'Venda de pacote no PDV'
                } else if (detail.appointmentInvoiceId) {
                    source = 'Venda realizada no atendimento (carrinho)'
                } else {
                    source = 'Última venda no PDV antes do atendimento'
                }
            } else if ((detail.details.comissionPriceSource as any) === 'table' || detail.details.comissionPriceSource === 'price') {
                // table / price legado. agora só usamos price.
                source = 'Tabela de preços'
            } else {
                source = '-'
            }
        } else if (detail.source === 'pos') {
            source = 'Venda realizada'
        } else {
            source = 'Lançamento manual em "Comissões e Salários"'
        }
        if (detail.appointmentItemInvoiceId) {
            invoice = await window.api.pos.invoices.getOne(detail.appointmentItemInvoiceId)
        }
    })

    async function cancelComission() {
        if (detail.source === 'scheduler') {
            await window.api.schedulers.appointments.comissionsChangeStatus(detail.sourceItemId, false)
        }
        if (detail.source === 'pos') {
            await window.api.pos.invoices.comissionsChangeStatus(detail.sourceItemId, false)
        }
        dispatch('change', detail)
    }

    async function activateComission() {
        if (detail.source === 'scheduler') {
            await window.api.schedulers.appointments.comissionsChangeStatus(detail.sourceItemId, true)
        }
        if (detail.source === 'pos') {
            await window.api.pos.invoices.comissionsChangeStatus(detail.sourceItemId, true)
        }
        dispatch('change', detail)
    }

    function showAppointment() {
        window.popover({
            act: 'appointment-form',
            data: {
                appointmentId: detail.sourceId,
            },
        })
    }

    function showPOS() {
        window.popover({
            act: 'pos-form',
            data: {
                invoiceId: detail.source === 'pos' ? detail.sourceId : detail.appointmentItemInvoiceId,
            },
        })
    }

    function showPerson() {
        window.person('show', detail.personId, 1)
    }

    async function invoiceOnChange(event) {
        try {
            const newInvoiceId = event.detail?.invoiceId || null
            console.log('newInvoiceId', newInvoiceId)
            await window.api.schedulers.appointments.setItemInvoice(detail.sourceItemId, newInvoiceId)
            dispatch('change', detail)
        } catch (error) {
            window.error(error)
        }
    }
</script>

<Zact>
    {#if detail.details.comissionCanceled}
        <Zbutton on:click={activateComission} label="Reativar Comissão"></Zbutton>
    {:else}
        <Zbutton on:click={cancelComission} label="Estornar Comissão"></Zbutton>
    {/if}
    <div class="spacer"></div>
    {#if detail.source === 'scheduler'}
        <Zbutton on:click={showAppointment} label="Agendamento"></Zbutton>
    {/if}
    {#if detail.appointmentItemInvoiceId || (detail.source === 'pos' && detail.sourceId)}
        <Zbutton on:click={showPOS} label="Venda"></Zbutton>
    {/if}
    <Zbutton on:click={showPerson} label="Pessoa"></Zbutton>
</Zact>
<div class="m-3">
    <ZContainer>
        <Zframe size={8} class="" title="Detalhes do lançamento" headline="">
            <div class="show-details -content">
                <div class="row">
                    <div class="col">
                        <span class="title-badge">Cliente</span>
                        <span>
                            {detail.person?.name}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="title-badge">Data</span><span>{dayjs(detail.date).format('DD/MM/YYYY HH:mm:ss')}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="title-badge">Item</span><span>{detail.service.name}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="title-badge">Valor base</span><span>{window.api.utils.utils.toReal(detail.total)}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="title-badge">Origem do valor base</span><span>{source}</span>
                    </div>
                </div>
                {#if invoice}
                    <div class="row">
                        <div class="col invoice-col">
                            <span class="title-badge">Venda vinculada</span><span>
                                <ZentitySelect fonte="venda" params={{ personId: detail.personId, serviceId: detail.serviceId }} bind:value={invoice} on:change={invoiceOnChange} />
                            </span>
                        </div>
                    </div>
                {/if}
            </div>
        </Zframe>
        <Zframe size={4} title="Detalhes da comissão" headline="">
            <div class="show-details -content">
                {#if detail.source !== 'manual'}
                    <!-- herança campo a campo: "personalizada" = ao menos uma taxa veio da tabela do profissional -->
                    <div class="row">
                        <div class="col">
                            <span class="title-badge">Taxa aplicada</span>
                            <span>
                                {detail.details?.comissionRateCustomized ? 'Personalizada do profissional' : 'Cadastro do serviço'}
                            </span>
                        </div>
                    </div>
                {/if}
                <div class="row">
                    <div class="col">
                        <span class="title-badge">(+) Percentual</span>
                        <span>
                            {window.api.utils.utils.toReal(detail.details.comissionPercentage)}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="title-badge">(+) Fixo</span>
                        <span>{window.api.utils.utils.toReal(detail.details.comissionFixed)}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="title-badge">(-) Descontos</span>
                        <span>{window.api.utils.utils.toReal(-detail.details.comissionCosts)}</span>
                    </div>
                </div>
                {#if detail.details.comissionFeeDebt}
                    <div class="row">
                        <div class="col">
                            <span class="title-badge">(=) Bruto</span>
                            <span>{window.api.utils.utils.toReal(detail.comission + detail.details.comissionFeeDebt)}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="title-badge">(-) Taxa meio pgto</span>
                            <span>{window.api.utils.utils.toReal(-detail.details.comissionFeeDebt)}</span>
                        </div>
                    </div>
                {/if}
                <div class="row">
                    <div class="col">
                        <span class="title-badge">(=) Líquido</span>
                        <span>{window.api.utils.utils.toReal(detail.comission)}</span>
                    </div>
                </div>
            </div>
        </Zframe>
    </ZContainer>
</div>

<style>
    .show-details .row {
        font-size: 14px;
        padding: 8px;
        border-bottom: 1px solid #99999918;
    }

    .show-details .invoice-col {
        display: flex;
        align-items: center;
    }
</style>
